import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useMemo } from "react";
import useLocalStorage from "../../hooks/useLocalStorage";
import {
  appRoutes,
  MATCHING_PROCESS_PATH,
  SIGNUP_PATH,
  SURVEY_PATH
} from "../../constants/routes";
import { MATCHING_DONE, SURVEY_DONE } from "../../constants/storage";
import { isSignedInState } from "../../store/slices/user";
import { useAppSelector } from "../../store";

const AuthRoute = () => {
  const { pathname, state } = useLocation();
  const { getStorageItem } = useLocalStorage();
  const isSignedIn = useAppSelector(isSignedInState);
  const currentPath = useMemo(
    () => pathname.split("/").filter(part => part.length > 0).at(-1),
    [pathname]
  );

  const isSurveyFinished = getStorageItem(SURVEY_DONE) ?? false;
  const isMatchingFinished = getStorageItem(MATCHING_DONE) ?? false;

  if (isSignedIn) {
    return <Navigate to={state?.path ? `${state.path}` : appRoutes.root} />;
  }

  if (currentPath === SURVEY_PATH && isSurveyFinished) {
    return <Navigate to={appRoutes.signUp} />;
  }

  if (currentPath === MATCHING_PROCESS_PATH && (!isSurveyFinished || isMatchingFinished)) {
    return <Navigate to={appRoutes.survey} />;
  }

  if (currentPath === SIGNUP_PATH && !isSurveyFinished) {
    return <Navigate to={appRoutes.survey} />;
  }

  if (currentPath === SIGNUP_PATH && !isMatchingFinished) {
    return <Navigate to={appRoutes.matchingProcess} />;
  }

  return <Outlet />;
};

export default AuthRoute;
